var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "laptop-icon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#laptop-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.654V9.577c0-.497.177-.923.531-1.277a1.74 1.74 0 011.277-.53h15.384c.497 0 .923.176 1.277.53.354.354.531.78.531 1.277v12.077h1.25c.212 0 .39.072.534.215a.726.726 0 01.216.535c0 .213-.072.39-.216.534a.726.726 0 01-.534.216H5.25a.726.726 0 01-.534-.216.726.726 0 01-.216-.534c0-.213.072-.391.216-.535a.726.726 0 01.534-.215H6.5zm7.942 0h3.116a.424.424 0 00.31-.133.424.424 0 000-.62.425.425 0 00-.31-.132h-3.116a.424.424 0 00-.31.133.424.424 0 000 .62.424.424 0 00.31.132zM8 19.269h16V9.577a.3.3 0 00-.087-.221.3.3 0 00-.22-.087H8.307a.3.3 0 00-.221.087.3.3 0 00-.087.221v9.692z",
    fill: "#212121"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/laptop-icon.a32c1e79.svg";
export { SvgLaptopIcon as ReactComponent };